import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'
import { useBaseStore } from '@haskoning/vue-basestore'
import { computed } from 'vue'
import { useAuthorizationStore } from '@/stores/authorization'
import type { Material } from '@/stores/type/material.type'

const { api } = useApi()
const baseURL = API.CORE.MATERIALS.INDEX

export const useMaterialStore = defineStore('material', () => {
  const authorizationStore = useAuthorizationStore()

  const canChangeMaterial = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['change_material']
    })
  })

  const baseStore = useBaseStore<Material>({ service: baseURL, api })

  function resetAll() {
    baseStore.reset()
  }

  return {
    ...baseStore,
    canChangeMaterial,
    resetAll
  }
})
